import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';
import { TitleAndDescriptionProps } from './BaseStep';

interface StyleProps {
  description?: string;
  marginBottom?: number;
}

const RootDiv = styled.div`
  font-weight: 400;
  color: ${getColor('BLACK_80')};
  line-height: 24px;
  margin-bottom: ${(props: StyleProps) => (props.marginBottom ? `${props.marginBottom}px` : '24px')};
  font-size: 16px;
`;

const H3 = styled.h3`
  color: ${getColor('BLACK')};
  font-size: 20px;
  font-weight: 600;
  margin-bottom: ${(props: StyleProps) => (props.description ? '4px' : 0)};
  line-height: 30px;
`;

export const SecondaryTitleDescription = ({ title, description, marginBottom }: TitleAndDescriptionProps) => {
  return (
    <RootDiv marginBottom={marginBottom}>
      <H3>{title}</H3>
      {description ?? <p>{description}</p>}
    </RootDiv>
  );
};
